module.exports = __webpack_public_path__ + "img/icon_std.1296583d.png";